module.exports = __webpack_public_path__ + "images/16a4d122049e6d71468d418be4262b6a-los cabos.jpg";